<template>
  <v-dialog v-model="showDialog" persistent max-width="800">
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Edição de Evento</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="close()" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <GrupoSolucaoCombobox
              @changeGroupSolution="changeGroupSolution"
              :title="'Eixo'"
              :filter="{ grupoSolucaoId: payload.groupSolutionId }"
              :groupSolutionId="payload.groupSolutionId"
            ></GrupoSolucaoCombobox>
          </v-col>
          <v-col v-if="payload.groupSolutionId">
            <SolutionCombobox
              ref="solutionCombobox"
              :filterSolutions="solucoes"
              :filter="{ solucaoId: payload.solutionId }"
              :multiple="false"
              :returnObject="true"
              @changeSolution="changeSolution"
              :title="'Produto'"
              :solutionIds="payload.solutionId"
            ></SolutionCombobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6">
            <v-text-field
              v-model="payload.nome"
              :disabled="!!payload.groupSolutionId && !!payload.solutionId"
            ></v-text-field>
          </v-col>
          <v-col>
            <ComboboxContratos :filter="payload"></ComboboxContratos>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.inicioString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Início"
              placeholder="00/00/0000 00:00"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.fimString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Término"
              placeholder="00/00/0000 00:00"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="9" sm="9" lg="9">
            <v-combobox
              v-model="payload.municipios"
              :items="municipios"
              chips
              clearable
              :label="isGov ? 'Projetos' : 'Municípios'"
              item-text="nome"
              item-value="municipioId"
              multiple
            >
            </v-combobox>
          </v-col>

          <v-col>
            <v-btn color="info" outlined text @click="selecionarTodos()"
              >Selecionar Todos</v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Observações"
              v-model="payload.observacoes"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" text @click="close()">Fechar</v-btn>

        <v-btn color="info" @click="save()">Salvar</v-btn>
        <v-btn color="error" @click="excluir()">Excluir evento</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityAPI } from "@/modules/city";
import { eventAPI } from "@/modules/event";
import { mapActions, mapGetters } from "vuex";
import SolutionCombobox from "@/modules/solution/components/Combobox.vue";
import { compare } from "@/helpers/orderByAsc";
import GrupoSolucaoCombobox from "@/modules/group-solution/components/Combobox.vue";
import { solutionAPI } from "@/modules/solution";
import ComboboxContratos from "@/modules/contratos/components/ComboboxContratos.vue"; // Importar o componente ComboboxContratos
import Swal from "sweetalert2";
export default {
  name: "AppModalEditEvent",
  props: {
    dialogEdicao: { type: Boolean, default: false },
    dados: { type: Object },
  },
  components: {
    GrupoSolucaoCombobox,
    SolutionCombobox,
    ComboboxContratos,
  },

  computed: {
    ...mapGetters(["isAT", "isGov"]),
  },
  data() {
    return {
      menu: "",
      menu2: "",
      date: null,
      time: null,
      showDialog: this.dialogEdicao,
      municipios: [],
      solucoes: [],
      payload: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    changeGroupSolution(e) {
      this.payload.groupSolutionId = e;

      this.setLoading(true);
      solutionAPI
        .list()
        .then((resp) => {
          this.solucoes = resp.data
            .filter((item) => item.grupoSolucaoId === e)
            .sort((a, b) => compare(a, b, "nome"));

          this.setLoading(false);
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log("err ", err);
          this.setLoading(false);
          this.$notification.error(
            `Erro ao obter ${this.isAT ? "iniciativas" : "soluções"}`
          );
        });
    },
    changeSolution(e) {
      this.payload.solutionId = e.solucaoId;
      this.payload.nome = e.nome;
    },
    save() {
      this.setLoading(true);
      this.payload.solucaoId = this.payload.solutionId;
      this.payload.grupoSolucaoId = this.payload.groupSolutionId;
      this.payload.contratoId =
        (this.payload.contratos && this.payload.contratos.contratoId) || null;
      eventAPI
        .update(this.payload)
        .then((resp) => {
          this.$emit("onSave");
          this.showDialog = false;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao atualizar ${this.isAT ? "agenda" : "encontro"}`
          );
        });
    },

    excluir() {
      this.setLoading(true);
      Swal.fire({
        title: `Excluir o evento ${this.payload.nome}?`,
        text: "Essa ação irá excluir o mesmo evento em todos os municípios que o possuem e não poderá ser desfeita.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sim, excluir!",
      }).then((result) => {
        if (result.isConfirmed) {
          eventAPI
            .delete(this.payload.eventoId)
            .then((resp) => {
              this.$emit("onSave");
              this.showDialog = false;
            })
            .catch((resp) => {
              this.setLoading(false);
              this.$notification.error(
                `Erro ao excluir ${this.isAT ? "agenda" : "encontro"}`
              );
            });
        } else {
          this.setLoading(false);
        }
      });
    },
    loadCities() {
      this.setLoading(true);
      cityAPI
        .listNames()
        .then((resp) => {
          this.municipios = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter municípios");
        });
    },
    close() {
      this.$emit("closeDialog");
    },
    selecionarTodos() {
      this.payload.municipios = this.municipios;
    },
  },
  watch: {
    dialogEdicao(value) {
      this.showDialog = value;
      this.payload = { ...this.dados };
      this.payload.groupSolutionId = this.dados.grupoSolucaoId;
      this.payload.solutionId = this.dados.solucaoId;
      this.payload.contratos = this.dados.contrato;
      this.$forceUpdate();
    },
    dados: {
      handler(val, oldVal) {
        this.payload = { ...val };
        this.payload.groupSolutionId = val.grupoSolucaoId;
        this.payload.solutionId = val.solucaoId;
        this.payload.contratos = this.dados.contrato;

        this.$forceUpdate();
      },
      deep: true,
    },
  },
  created() {
    this.loadCities();
  },
};
</script>
